import { Box, Paper, Skeleton } from '@mui/material';

export const ProfileSkeleton = () => {
  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 4 },
          borderRadius: 1.5,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        {/* Avatar Section Skeleton */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            mb: { xs: 4, md: 5 },
            pb: { xs: 4, md: 5 },
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Box sx={{ position: 'relative' }}>
            <Skeleton variant="circular" width={116} height={116} animation="wave" />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
            <Skeleton variant="text" width={180} height={32} animation="wave" />
            <Skeleton variant="text" width={100} height={20} animation="wave" />
          </Box>
        </Box>

        {/* Form Sections Skeleton */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 4,
            alignItems: 'stretch',
          }}
        >
          {/* Profile Form Skeleton */}
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box>
              <Skeleton variant="text" width={60} height={20} sx={{ mb: 1 }} animation="wave" />
              <Skeleton variant="rounded" height={52} sx={{ borderRadius: 2 }} animation="wave" />
            </Box>

            <Box>
              <Skeleton variant="text" width={60} height={20} sx={{ mb: 1 }} animation="wave" />
              <Skeleton variant="rounded" height={52} sx={{ borderRadius: 2 }} animation="wave" />
            </Box>

            <Skeleton
              variant="rounded"
              width={140}
              height={44}
              sx={{ mt: 1, borderRadius: 2 }}
              animation="wave"
            />
          </Box>

          <Box sx={{ width: '1px', bgcolor: 'divider', display: { xs: 'none', md: 'block' } }} />

          {/* Password Form Skeleton */}
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box>
              <Skeleton variant="text" width={120} height={24} sx={{ mb: 0.5 }} animation="wave" />
              <Skeleton variant="text" width={280} height={20} animation="wave" />
            </Box>

            <Box>
              <Skeleton variant="rounded" height={52} sx={{ borderRadius: 2 }} animation="wave" />
            </Box>

            <Box>
              <Skeleton variant="rounded" height={52} sx={{ borderRadius: 2 }} animation="wave" />
            </Box>

            <Box>
              <Skeleton variant="rounded" height={52} sx={{ borderRadius: 2 }} animation="wave" />
            </Box>

            <Skeleton
              variant="rounded"
              height={44}
              sx={{ mt: 1, borderRadius: 2 }}
              animation="wave"
            />
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};
